<template>
  <div v-if="isSceneLoaded" class="u-wrapper-panel u-pointer-none">
    <!-- <app-image v-if="data.avLogo.length" :width="300" :id="data.avLogo[0].id" class="scene-logo" :class="{'scene-logo--right': data.avLogoPosition === 'right'}" /> -->
    <screen
      @currentTime="onCurrentTime"
      :position="screenPos"
      :idVimeo="vimeo"
      :idYoutube="youtube"
      :video="video"
    />
    <transition name="t-fader">
      <question
        v-for="(question, index) in questions"
        :data="question"
        :bumpers="bumpers"
        :key="index"
        :time="currentTime"
        @end="onEnded"
        ref="questions"
        v-if="index === currentIndex"
      />
    </transition>
    <score :position="scorePos" />
    <div @click="onClick" class="u-wrapper-panel u-cursor-pointer" :class="{'u-pointer-all': isOver}" />
    <app-title :text="title" />
  </div>
</template>

<script>
import Screen from '@/components/3D/Screen'
import Question from '@/components/3D/Question'
import Score from '@/components/3D/Score'
import AppTitle from '@/components/AppTitle'

import { FitTo } from '@/utils/FitTo'
import { mapper, toScreenPosition } from '@/utils/Maths'
import { Timeline } from '@/utils/TimelineVideo'

import { Scenery } from '@/webGL/objects/Scenery'
import { Bumper } from '@/webGL/objects/Bumper'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { webGL } from '@/webGL/WebGL'

import objectsData from '@/assets/data/objects'

import { Vector3, Box3 } from 'three'

export default {
  components: {
    Screen,
    Question,
    Score,
    AppTitle
  },

  computed: {
    questions () {
      return this.$store.getters['data/questions']
    },
    vimeo () {
      return this.$store.getters['data/vimeo']
    },
    youtube () {
      return this.$store.getters['data/youtube']
    },
    video () {
      return this.$store.getters['data/video']
    },
    screenPos () {
      return this.$store.getters['global/screenPos']
    },
    scorePos () {
      return this.$store.getters['global/scorePos']
    },
    title () {
      return this.$store.getters['data/title']
    }
  },

  data () {
    return {
      bumpers: [],
      isSceneLoaded: false,
      currentIndex: -1,
      isOver: false,
      currentTime: 0
    }
  },

  created () {
    this.fitTo = new FitTo(webGL.camera)

    this.onResize()

    this.timeline = new Timeline(this.onQuestion)
    this.timeline.setData(this.$store.getters['data/timeline'])
    this.timeline.isStarted = true
  },

  mounted () {
    this.scenery = new Scenery('/objects/scenery--03.glb')
    webGL.scene.add(this.scenery)
    this.scenery.promise.then(() => {
      this.scenery.color = this.$store.getters['global/mainColor']
      this.scenery.bumpers.forEach((bumper, index) => {
        this.bumpers.push(new Bumper(bumper, index, this.$device.getIntersectPosition))
      })

      this.isSceneLoaded = true
    })
    this.addObjects()

    // this.$hub.on('click', this.onClick)
    // new OrbitControls( webGL.camera, this.$root.$el)
  },

  methods: {
    onResize () {
      const box = new Box3(
        new Vector3(this.screenPos.x - (100 * .5), 0, this.screenPos.z), //min
        new Vector3(this.screenPos.x + (100 * .5), this.screenPos.y + (56.2 * .5), this.screenPos.z) //max
      )

      const { position, look } = this.fitTo.fit(box, {
        top: .7,
        right: .8,
        bottom: .9,
        left: .8
      }, {vector: new Vector3(0, .1, .9)})

      webGL.camera.position.copy(position)
      webGL.camera.look.copy(look)
    },
    async addObjects () {
      // this.timeline.start()

      this.onResize()
    },

    onUpdate () {
      this.checkBumpersOver()
    },
    checkBumpersOver () {
      this.isOver = false
      for (let i = 0 ; i < this.bumpers.length ; i++) {
        if (this.bumpers[i].isOver) {
          this.isOver = true
          break;
        }
      }
    },
    onClick () {
      this.currentInfo = this.isOverIndex

      this.bumpers.forEach(bumper => bumper.onClick())
    },
    onCurrentTime (value) {
      this.currentTime = value

      this.timeline.onUpdate(value)
    },
    onQuestion (index) {
      this.currentIndex = index
    },
    onEnded (index) {
      this.currentIndex = -1
    },
  }
}
</script>

<style lang="stylus">
.scene-logo
  position absolute
  bottom 20px
  left 20px
  width 200px
  
  &--right
    left auto
    right 20px
</style>

